import { msg } from '@lingui/core/macro'
import { createFileRoute, Outlet } from '@tanstack/react-router'
import { type CatalogSearch, decodeCatalogSearch } from '~/lib/catalog-search'
import { titleFor } from '~/lib/route-title'

export const Route = createFileRoute('/_authenticated/$workspaceSlug/products')({
  component: CatalogLayout,
  head: () => ({ meta: [{ title: titleFor(msg`Products`) }] }),
  // Lights the rail's tile and swaps the second column.
  // Every filter lives in the URL, so a filtered view is a shareable link and
  // the grouped landing is simply "nothing set". Declared on the layout so the
  // brand and collection pages inherit the same chips.
  validateSearch: (search: Record<string, unknown>): CatalogSearch => decodeCatalogSearch(search),
})

// Pass-through layout: the catalog itself, the product deep link, and the
// brand and collection pages are child routes.
function CatalogLayout() {
  return <Outlet />
}
